import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import Navigation  from '@dashboard/navigation';
import Guest       from '@dashboard/parts/guest';

// -------------------------------------------------------


class Dashboard extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      data : Object.assign({}, this.props.data),
      tab  : Utils.getLocalData({ id: 'dashboard/tab', default: 'home' }),
    };
  }
  // -------------------------------------------------------
  
  /*
   * データの更新
   */
  updateData(data) {
    this.setState({ data: Object.assign(this.state.data, data) });
  }
  // -------------------------------------------------------
  
  /*
   * ナビの変更
   */
  changeNavigation(tab) {
    this.setState({ tab: tab });
    Utils.saveLocalData({ id: 'dashboard/tab', data: tab });
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.data;
    let data = this.state.data;
    data.event = {
      updateData: this.updateData.bind(this),
    }
    
    let tab = 'guest';
    let menus = [
      { id: 'guest', name: 'プロジェクト', icon: 'account_box', html: <Guest /> }
    ];
    
    return (
      <div id="dashboard">
        <Navigation data={data} menus={menus} tab={tab} change_ev={this.changeNavigation.bind(this)} />
        
        <div className="dashboard-container">
          { menus.map((d, key) => {
            if( d.id != tab ) return null;
            
            let _html = React.cloneElement(d.html, { key: key, data: data, base: base })
            return _html;
          })}
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Dashboard;